'use client';

import { FC, PropsWithChildren } from 'react';
import { isEmpty } from '@cat-ecom/common/utils/commonUtils';
import { Portal, Modal } from 'components/pcc-components';
import { ROOT_PORTALS } from 'constants/targets';
import { useDealerLocatorModal } from '../dealer-locator-modal-context';
import { useDealerLocatorLoader } from '../dealer-locator-loader-context';
import { useLogout } from 'hooks/use-logout';

export const DealerLocatorModalWrapper: FC<
  Readonly<{ isWelcomeModal?: boolean } & PropsWithChildren>
> = ({ isWelcomeModal, children }) => {
  const dealerLocatorModal = useDealerLocatorModal();
  const dealerLocatorLoader = useDealerLocatorLoader();
  const { logout, logoutUrl } = useLogout();

  const handleLogout = () => {
    logout();
    if (!isEmpty(logoutUrl)) {
      window.location.href = logoutUrl;
    }
  };

  const onModalClose = () => {
    if (isWelcomeModal) {
      handleLogout();
    }
    dealerLocatorModal.modalControl.close();
  };

  return (
    <Portal id={ROOT_PORTALS}>
      <Modal
        {...dealerLocatorModal?.modalProps}
        disableBackdropClick={
          dealerLocatorLoader?.isDealerLocatorLoading ||
          dealerLocatorModal?.modalProps?.disableBackdropClick
        }
        dismissible={
          !dealerLocatorLoader?.isDealerLocatorLoading ||
          dealerLocatorModal?.modalProps?.dismissible
        }
        onBlModalClose={onModalClose}
      >
        {children}
      </Modal>
    </Portal>
  );
};
